import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { searchParamsToObject } from '@packages/shared/src/utils/searchParamsToObject/searchParamsToObject';

import { getInspiringSearchSettingsInternal } from './useInspiringSearchSettings.shared';

/**
 * Get the activation status for Inspiring Search features (client-side)
 */
export const useInspiringSearchSettings = () => {
  const config = useConfig();
  const searchParams = useSearchParams();

  return useMemo(
    () => getInspiringSearchSettingsInternal(searchParamsToObject(searchParams), config),
    [config, searchParams],
  );
};
